import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface Filters {
  date__gte?: string;
  date__lte?: string;
  user?: string | number;
  violations?: string | boolean;
  form?: string | boolean;
  ordering?: string;
}

export type DataState = {
  error: any;
  logs: any[];

  filters: Filters;

  isLoadingLogs: boolean;
  isRefreshData: boolean;

  dataTotalCount: number;
  dataCurrentCount: number;
};

const initialState: DataState = {
  error: null,
  logs: [],

  filters: {},

  isLoadingLogs: false,
  isRefreshData: false,

  dataTotalCount: 0,
  dataCurrentCount: 0,
};

export const LogSlice = createSlice({
  name: 'log',
  initialState,
  reducers: {
    loadLogs(state, action: PayloadAction<any>) {
      state.logs = action.payload;
    },
    setLoadingLogs(state, action: PayloadAction<any>) {
      state.isLoadingLogs = action.payload;
    },

    setRefreshData(state, action: PayloadAction<any>) {
      state.isRefreshData = action.payload;
    },

    setTotalCountData(state, action: PayloadAction<any>) {
      state.dataTotalCount = action.payload;
    },
    setCurrentCountData(state, action: PayloadAction<any>) {
      state.dataCurrentCount = action.payload;
    },

    setFilters(state, action: PayloadAction<any>) {
      state.filters = action.payload;
    }
  },
});

export default LogSlice.reducer;
